module.exports = __webpack_public_path__ + "static/img/3.7cea2233.png";